import { DynamicFormV2Palette } from "@mui/material";

export type FormDialogComponentTokenType = {
  textColor: string;
  titleColor: string;
  backgroundColor: string;
  iconColor: string;
  iconBackgroundColor: string;
  backdropColor: string;
  borderColor?: string;
};

export const assignDialogComponentTokens = (formsPalette: DynamicFormV2Palette["forms"], mode: "light" | "dark") => {
  const isDark = mode === "dark";
  return {
    textColor: isDark ? formsPalette.text.intense : formsPalette.text.moderate,
    titleColor: formsPalette.text.intense,
    backgroundColor: isDark ? formsPalette.surface.moderate : formsPalette.surface.supershy,
    iconColor: formsPalette.text.brand,
    iconBackgroundColor: isDark ? formsPalette.surface.supershy : formsPalette.surface.quiet,
    backdropColor: isDark ? "rgba(0, 0, 0, 0.8)" : "rgba(0, 0, 0, 0.4)",
    ...(isDark && { borderColor: formsPalette.border.intense }),
  } as FormDialogComponentTokenType;
};
